document.addEventListener("DOMContentLoaded", function () {
    const banner = document.querySelector('.coupon-banner-container.fixed');
    if (banner) {
        requestAnimationFrame(() => {
            banner.style.opacity = '0';
            banner.style.display = 'flex';
            requestAnimationFrame(() => {
                banner.style.transition = 'opacity 0.3s ease-in-out';
                banner.style.opacity = '1';
            });
        });
    }
});
